import { TmApiValidationError } from '@/core/error/transport/tmApiValidationError'

export class TmAuthVerificationInvalidCodeError extends TmApiValidationError {}
